var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.iconStyling},[_c('a',{attrs:{"tabindex":"0","data-bs-toggle":"popover","data-bs-trigger":"focus","data-bs-content":_vm.popoverContent}},[_c('i',{staticClass:"bi",class:_vm.icon})]),_vm._v(" "),_c('span',{staticClass:"visually-hidden",attrs:{"id":_vm.textSlotId}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }